import { atom } from 'recoil'
import { persistAtom } from '../persist'

export type BrowserBackState = {
  page: string
  text: string
}

export const initialBrowserBackState: BrowserBackState = {
  page: '',
  text: '',
}

export const browserBackState = atom<BrowserBackState>({
  key: 'browserBackState',
  default: initialBrowserBackState,
  effects_UNSTABLE: [persistAtom],
})
